
<template>
  <v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
    <v-dialog v-model="permitted_dialog" max-width="400px">
      <v-card>
        <v-card-text>
          <div class="text-center">
            <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
            <p>{{message}}</p>
            <v-progress-circular
              :size="70"
              :width="2"
              :value="100"
              color="error"
              class="mb-4 mr-4"
            >
              <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
            </v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
  <v-container v-else v-show="permitted != null" class="pt-0" fluid>
    <v-snackbar
      :value="showMessage()"
      multi-line
      color="#686868"
      top
      
    >
      {{message}}
    </v-snackbar>
    <v-card flat >
    <v-toolbar dense flat color="#2A353D">
      <v-toolbar-title class="white--text subtitle-1 font-weight-normal">{{heading}}</v-toolbar-title>
      <v-spacer/>
      <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
      <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>

      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        bottom
        color="#81DBF6"
      ></v-progress-linear>
    </v-toolbar>
    </v-card>

    <v-alert
      class="my-2"
      dense text
      color="#2A353D"
    >
      <v-row align="center" class="mx-2">
        <v-col class="py-0">
          <v-select
            hide-details
            filled rounded background-color="white" dense clearable
            v-model="parameters.CustodianID"
            :items="allCustodians.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            class="mx-1"
            @change="getInterestBearingAssets()"
            item-text="CustodianName"
            item-value="CustodianID"
            placeholder="----"
            label="Custodian"
          ></v-select>
        </v-col>
        <v-col class="py-0">
          <v-select
            hide-details
            filled rounded background-color="white" dense clearable
            v-model="parameters.AccountID"
            :items="allClientAccounts.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            class="mx-1"
            @change="getInterestBearingAssets()"
            :item-text="item => item.tblclient.Forename + ` ` + item.tblclient.MajorName +` - ` + item.AccountNumber"
            item-value="AccountID"
            placeholder="----"
            label="Account"
          ></v-select>
        </v-col>
        <v-col class="py-0">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="parameters.effective_date"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="parameters.effective_date"
                class="mx-1"
                label="Effective Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                hide-details
                dense filled rounded background-color="white" color="#2A353D"
                :rules="TextFieldRules"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker @change="getInterestBearingAssets()" color="#2A353D" v-model="parameters.effective_date" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
            <v-btn outlined small color="#2A353D" @click="$refs.menu.save(parameters.effective_date)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-alert>

    <v-sheet class="mt-4 elevation-12">
      <v-toolbar color="white" dark dense flat>
        <v-spacer/>
        <v-btn @click="generatePDF()" outlined small color="#2A353D" v-on="on">
          PRINT<v-icon small>mdi-printer</v-icon>
        </v-btn>

        <template v-slot:extension>
          <v-tabs light color="#2A353D" v-model="tabs" fixed-tabs>
            <v-tabs-slider color="#2A353D"></v-tabs-slider>
            <v-tab>Running Assets</v-tab>
            <v-tab>Deal Assets</v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <v-data-table
            :fixed-header="true"
            :headers="running_headers"
            :items="running_assets"
            :height="390"
            hide-default-footer
            disable-pagination
          >
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-data-table
            :fixed-header="true"
            :headers="deal_headers"
            :items="deal_assets"
            :height="390"
            hide-default-footer
            disable-pagination
          >
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-sheet>
  </v-container>
</template>

<script>
import reportsService from '../services/reports.service';
import UserService from '../services/user.service';
import {mapGetters} from "vuex";
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  data () {
    return {
      parameters: {},
      running_assets: [],
      deal_assets: [],
      valid: true,
      filter_dialog: false,
      loading: false,
      search: '',
      message: '',
      menu: false,
      heading: "Interest Bearing Assets",
      menu2: false,
      permitted: null,
      tabs: null,
      permitted_dialog: true,
      running_headers: [
        {
          text: 'AssetType',
          align: 'start',
          sortable: false,
          value: 'AssetType',
          width: 150
        },
        { text: 'BrokerNote', value: 'BrokerNote', sortable: false },
        { text: 'Instrument', value: 'Instrument', sortable: false, width: 150 },
        { text: 'PurchaseDate', value: 'PurchaseDate', sortable: false, width: 120 },
        { text: 'MaturityDate', value: 'MaturityDate', sortable: false, width: 120 },
        { text: 'Tenor', value: 'Tenor', sortable: false},
        { text: 'DealValue', value: 'DealValue', sortable: false},
        { text: 'ClientValue', value: 'ClientValue', sortable: false},
        { text: 'Rate', value: 'Rate', sortable: false},
        { text: 'TaxRate', value: 'TaxRate', sortable: false, width: 110 },
        { text: 'IsDiscounted', value: 'IsDiscounted', sortable: false},
        { text: 'GrossInterest', value: 'GrossInterest', sortable: false},
        { text: 'NetInterest', value: 'NetInterest', sortable: false},
        { text: 'MarketValue', value: 'MarketValue', sortable: false},
      ],
      deal_headers: [
        {
          text: 'BrokerNote',
          align: 'start',
          sortable: false,
          value: 'BrokerNote',
          width: 120
        },
        { text: 'AssetType', value: 'AssetType', sortable: false, width: 150 },
        { text: 'CounterPartyName', value: 'CounterPartyName', sortable: false, width: 200 },
        { text: 'Instrument', value: 'Instrument', sortable: false },
        { text: 'PurchaseDate', value: 'PurchaseDate', sortable: false, width: 120 },
        { text: 'MaturityDate', value: 'MaturityDate', sortable: false, width: 120},
        { text: 'InstrumentValue', value: 'InstrumentValue', sortable: false},
        { text: 'IsDiscount', value: 'IsDiscount', sortable: false},
        { text: 'GrossInterest', value: 'GrossInterest', sortable: false},
        { text: 'NetInterest', value: 'NetInterest', sortable: false, width: 110 },
        { text: 'MaturityValue', value: 'MaturityValue', sortable: false},
      ],
    }
  },

  computed: {
    ...mapGetters([
      "currentImage",
      "allCustodians",
      "identity",
      "allCountries",
      "allCities",
      "currentSystemDate",
      "allClientAccounts"
    ]),

    currentUser() {
      return this.$store.state.auth.user;
    },

    Accounts(){
      return this.allClientAccounts.filter(a => a.tblclient.CustodianID == this.parameters.CustodianID)
    }
  },

  created(){
    this.parameters = {
      AccountID: 0,
      CustodianID: 0,
      effective_date: this.currentSystemDate.DayDate
    }
    this.loading = true;
    reportsService.getInterestBearingAssets(this.parameters)
    .then(response => {
      this.running_assets = response.data.running;
      this.deal_assets = response.data.deal;
      this.loading = false
    },
    error => {
    this.message =
      (error.response && error.response.data.message) ||
      error.message ||
      error.toString();
      this.loading = false
    })
  },

  methods: {
    getInterestBearingAssets() {
      if(this.parameters.AccountID == null || this.parameters.AccountID == ''){
        this.parameters.AccountID = 0
      }
      if(this.parameters.CustodianID == null || this.parameters.CustodianID == ''){
        this.parameters.CustodianID = 0
        this.parameters.AccountID = 0
      }
      if(this.parameters.effective_date == null || this.parameters.effective_date == ''){
        this.parameters.effective_date = this.currentSystemDate.DayDate
      }
      this.loading = true;
      reportsService.getInterestBearingAssets(this.parameters)
      .then(response => {
        this.running_assets = response.data.running;
        this.deal_assets = response.data.deal;
        this.loading = false;
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
        this.loading = false
      })
    },
    generatePDF() {
      const running_columns = [
        { title: 'AssetType',  dataKey: 'AssetType' },
        { title: 'BrokerNote', dataKey: 'BrokerNote' },
        { title: 'Instrument', dataKey: 'Instrument' },
        { title: 'PurchaseDate', dataKey: 'PurchaseDate' },
        { title: 'MaturityDate', dataKey: 'MaturityDate' },
        { title: 'Tenor', dataKey: 'Tenor' },
        { title: 'DealValue', dataKey: 'DealValue' },
        { title: 'ClientValue', dataKey: 'ClientValue' },
        { title: 'Rate', dataKey: 'Rate' },
        { title: 'TaxRate', dataKey: 'TaxRate'  },
        { title: 'IsDiscounted', dataKey: 'IsDiscounted' },
        { title: 'GrossInterest', dataKey: 'GrossInterest' },
        { title: 'NetInterest', dataKey: 'NetInterest' },
        { title: 'MarketValue', dataKey: 'MarketValue' },
      ];

      const deal_columns = [
        { title: 'BrokerNote',  dataKey: 'BrokerNote' },
        { title: 'AssetType', dataKey: 'AssetType' },
        { title: 'CounterPartyName', dataKey: 'CounterPartyName' },
        { title: 'Instrument', dataKey: 'Instrument' },
        { title: 'PurchaseDate', dataKey: 'PurchaseDate' },
        { title: 'MaturityDate', dataKey: 'MaturityDate' },
        { title: 'InstrumentValue', dataKey: 'InstrumentValue' },
        { title: 'IsDiscount', dataKey: 'IsDiscount' },
        { title: 'GrossInterest', dataKey: 'GrossInterest' },
        { title: 'NetInterest', dataKey: 'NetInterest' },
        { title: 'MaturityValue', dataKey: 'MaturityValue' },
      ];

      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          var imgData = 'data:image/png;base64,'+ this.currentImage[0].data;

          doc.addImage(imgData, 'PNG', 0.5, 0.28, 1.3, 0.7);
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text(this.identity[0].OrgName, 8.5, 0.5);
          doc.setFontSize(6).text(this.identity[0].Phadd1, 8.5, 0.6);
          doc.setFontSize(6).text(this.allCities.filter(a => a.CityID == this.identity[0].PhCity).map(a => a.City)[0], 8.5, 0.7);
          doc.setFontSize(6).text(this.allCountries.filter(a => a.CountryId == this.identity[0].PhCountry).map(a => a.CountryName)[0], 8.5, 0.8);
          doc.setFontSize(6).text('email: ' + this.identity[0].OrgMail, 8.5, 0.9);
          doc.setFontSize(6).text('cell: ' + this.identity[0].OrgNumber, 8.5, 1.0);
          doc.setFontSize(10).text(this.heading + ' as at ' + this.parameters.effective_date, 0.5, 1.2);
          doc.setFontSize(8).text((this.parameters.CustodianID > 0? 'Custodian: ' + this.allCustodians.filter(a => a.CustodianID == this.parameters.CustodianID).map(a => a.CustodianName) + '        ' : '') + (this.parameters.AccountID > 0? 'Client: ' + this.Accounts.filter(a => a.AccountID == this.parameters.AccountID).map(a => a.tblclient.Forename) + ' ' + this.Accounts.filter(a => a.AccountID == this.parameters.AccountID).map(a => a.tblclient.MajorName) : ''), 0.5, 1.4);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 1.7, 10.5, 1.7);
          doc.setLineWidth(0.01).line(0.5, 1.9, 10.5, 1.9);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "landscape",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      if(this.running_assets != null && this.running_assets != [] && this.running_assets != ''){
        doc.autoTable({
          columns: running_columns,
          body: this.running_assets,
          margin: { left: 0.5, top: 1.7 },
          styles: {overflow: 'linebreak',
                  fontSize: 6},
          showHeader: 'everyPage',
          beforePageContent: function(data) {
            doc.setFontSize(8);
            doc.text("Running Assets", 0.5, data.settings.margin.top - 0.1);
          },
          theme: 'plain'
        });
      }
      if(this.deal_assets != null && this.deal_assets != [] && this.deal_assets != ''){
        doc.autoTable({
          startY: (doc.internal.pageSize.getHeight() - doc.autoTableEndPosY()) + doc.autoTableEndPosY(),
          columns: deal_columns,
          body: this.deal_assets,
          margin: { left: 0.5, top: 1.7 },
          styles: {
            overflow: 'linebreak',
            fontSize: 6
          },
          showHeader: 'everyPage',
          beforePageContent: function(data) {
            doc.setFontSize(8);
            doc.text("Deal Assets", 0.5, data.settings.margin.top - 0.1);
          },
          theme: 'plain'
        });        
      }
      addFooters(doc);
      doc.output('dataurlnewwindow');
    },
    getFiltered(current){
      this.CurrentRunningAssets = current;
    },
    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },
    validate () {
      this.$refs.form.validate()
      return this.valid
    },

    reset () {
      this.$refs.form.reset()
    },
  },

  mounted () {
    UserService.isReports().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }
}
</script>

<style scoped>
.v-btn {
  outline: none
}
</style>